import React, {useState, useEffect} from 'react'
import Color from '../../Components/Colors/Color'
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { useNavigate } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"
import '../Styles/AdminProductDetail.css'
import { addProduct, deleteProduct, uploadProductImage } from '../Controller/ProductController';
import { jwtDecode } from "jwt-decode";

const AdminAddProduct = () => {

    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [image, setImage] = useState(null);
    const [list, setList] = useState([]);
    const [description, setDescription] = useState("");
    const [inputNum, setInputNum] = useState(1);
    const [imageLink, setImageLink] = useState("");

    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [emptyTokenFlag, setEmptyTokenFlag] = useState(false);

    useEffect(() => {
        window.scrollTo(0,0);
    },[])

    useEffect(() => {
        if(!openSnackbar && emptyTokenFlag){
            setEmptyTokenFlag(false);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return
        }
    }, [openSnackbar && emptyTokenFlag])

    useEffect(() => {
        if(!openSnackbar && success){
            setSuccess(false);
            navigate('/admin-dashboard');
        }

    }, [success && openSnackbar]) 

    const onImageChange = (e) => {
        const file = e.target.files[0];
        setImage(file)
        if (file) {
            setImageLink(URL.createObjectURL(file));
        }
    };

    const handleListChange = (e, index) => {
        e.preventDefault();
        const {value} = e.target;
        const listTemp = [...list];
        listTemp[index] = value;
        setList(listTemp);
        console.log(list);
    }

    const increaseInput = (e) => {
        e.preventDefault();
        setInputNum(inputNum + 1)
        setList([...list, ""]); // Add a new empty string to the listInput array
        console.log(inputNum);
    }

    const decreaseInput = (index) => {
        // if(inputNum < 2){
        //     return;
        // }
        const listTemp = list.filter((_, i) => i !== index);
        setList(listTemp);
        setInputNum(inputNum - 1);
    }

    const handleMoveBack = (e) => {
        e.preventDefault();
        navigate('/admin-dashboard')
    }
    

    // const tokenChecker = async () => {
    //     let token = localStorage.getItem('authToken');
    //     if (!token) {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token not found, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         setEmptyTokenFlag(true);
    //     }

    //     console.log("HEREEE 2");

    //     let decodedToken = jwtDecode(token);

    //     if (decodedToken && decodedToken.exp * 1000 > Date.now()){

    //     } else {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token has expired, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         setEmptyTokenFlag(true);
    //     }
    // }

    function filterEmptyElements(list) {
        let tempList = list.filter(el => el !== '');
        return tempList.filter(el => el.name !== '');
    }


    const handleAddProduct = async (e) => {
        e.preventDefault();
        if(!name || !image || !description) return;

        // await tokenChecker();

        const filteredList = filterEmptyElements(list);
        setList(filteredList);

        const productImage = new FormData();
        productImage.append('imageFile', image);

        const product = {
            "name": name,
            "productLists": filteredList,
            "description": description
        }

        try{
         setLoading(true);

         const response = await addProduct(product);
         
         if(response.status === 200){
            const imageUploadResponse = await uploadProductImage(productImage, response?.data?.productId, true);
            if(imageUploadResponse.status === 200){
                setSeveritySnackbar('success');
                setSuccess(true);
            } else {
                await deleteProduct(response?.data?.productId);
                setSeveritySnackbar('error');
            }
            setMessageSnackbar(imageUploadResponse?.data?.message);
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
         } else {
            setSeveritySnackbar("error");
            setMessageSnackbar(response?.data?.message || "An error has occurred");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
            
         }
        } catch (error) {
            setSeveritySnackbar("error");
            setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
        } finally{
            setLoading(false);
        }
    }

    return(
        <>
            <div className='admin-product-detail-container' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}}>
                <div className='admin-product-detail-header-container'>
                    <h4 className='admin-product-detail-header new'>
                        New Product
                    </h4>
                    {/* <div className='admin-product-detail-delete-btn-container'>
    
                            <span className='fa-solid fa-trash-can admin-product-detail-delete-btn'></span> 
                     
                    </div> */}
                </div>
                <form className='admin-product-detail-contents' onSubmit={handleAddProduct}>
                    <div className='admin-product-detail-label-input-container'>
                        <label htmlFor='name' className='admin-product-detail-label'>
                            Name
                        </label>
                        <input 
                            type='text'
                            id='name'
                            className='admin-product-detail-input'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        /> 
                    </div>
                    <div className='admin-product-detail-label-input-container'>
                        <label htmlFor='description' className='admin-product-detail-label'>
                            Description
                        </label>
                        <textarea
                            id='description'
                            className='admin-product-detail-input'
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={7}
                            required
                        /> 
                    </div>
                    <div className='admin-product-detail-label-input-container'>
                        <label htmlFor='name' className='admin-product-detail-label'>
                            Product Lists
                        </label>
                        <div className='admin-product-detail-input-container'>
                            {list.map((input, index) => (
                                <div className='admin-product-detail-input-container-inside'>
                                    <button className='admin-product-decrease-list-btn' onClick={() => decreaseInput(index)}>
                                        -
                                    </button>
                                    <input
                                        key={index}
                                        type="text"
                                        className="admin-product-detail-input"
                                        onChange={(e) => handleListChange(e, index)}
                                        value={input.name}
                                    />
                                    
                                </div>
                            ))}
                            <button className='admin-product-add-list-btn' onClick={(e) => increaseInput(e)}>
                                +
                            </button>
                        </div>
                    </div>
                    <div className='admin-product-detail-label-input-container'>
                        <label htmlFor='image' className='admin-product-detail-label'>
                            Image
                        </label>
                        <input 
                            type='file'
                            id='image'
                            className='admin-product-detail-input image-input'
                            accept='.jpg, .jpeg, .png'
                            onChange={onImageChange}
                            required
                        /> 
                    </div>
                    {(image || imageLink) && 
                        <div className='admin-product-img-container'>
                            <img src={imageLink} alt='product-image' className='admin-product-img' />
                        </div>       
                    }
                    <div className='admin-product-detail-btn-container'>
                        <button className='admin-product-detail-cancel-btn' onClick={handleMoveBack}>
                            Cancel
                        </button>
                        <button className='admin-product-detail-save-btn' type='submit'>
                            Add
                        </button>
                    </div>
                </form>
                
                <div className={`loading-container-overlay ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='white' />
                </div>
            </div>

            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default AdminAddProduct;